import request from "@/utils/request";
import { baseURL } from "@/utils/getawayModule";

/**
 * 获取菜单
 * @returns {AxiosPromise}
 */
export function getMenu() {
    return request({
        url: `${baseURL.userApi}/users/getUserMenu`,
        method: 'get'
    })
}


/***
 * 查询用户列表 Get
 * @param query 查询的参数
 * @return request
 *
 * */
export function usersList(query) {
    return request({
        url: `${baseURL.userApi}/users`,
        method: 'get',
        params: query
    })
}


/**
 * 重置密码
 * @param data
 * @returns {AxiosPromise}
 */
export function editNewPassword(data) {
    return request({
        url: `${baseURL.userApi}/users/resetPassword`,
        method: 'post',
        data
    })
}

/***
 * 查询角色列表 Get
 * @param query 查询的参数
 * @return request
 *
 * */
export function rolesList(query) {
    return request({
        url: `${baseURL.userApi}/roles`,
        method: 'get',
        params: query
    })
}

/**
 * 保存角色
 * @param data
 * @returns {AxiosPromise}
 */
export function postRolesList(data) {
    return request({
        url: `${baseURL.userApi}/roles`,
        method: 'post',
        data: data
    })
}

/**
 * 删除角色
 * @param ids
 * @returns {AxiosPromise}
 */
export function deleteRolesById(ids) {
    return request({
        url: `${baseURL.userApi}/roles/${ids}`,
        method: 'delete'
    })
}


/***
 * 查询角色列表 Get
 * @param query 查询的参数
 * @return request
 *
 * */
export function verificationCode(query) {
    return request({
        url: `${baseURL.userApi}/users/sendModifyPhoneCode?phone=${query}`,
        method: 'get'
    })
}

/***
 * 更换手机号码 Post
 * @param data 更换的数据
 * @return request
 *
 * */
export function editPhone(data) {
    return request({
        url: `${baseURL.userApi}/users/updatePhone`,
        method: 'post',
        data: data
    })
}

/***
 * 更换手机号码 Post
 * @param data 更换的数据
 * @return request
 *
 * */
export function editPassword(data) {
    return request({
        url: `${baseURL.userApi}/users/modifyPassword`,
        method: 'post',
        data: data
    })
}

/***
 * 新增用户 Post
 * @param data 新增的数据
 * @return request
 *
 * */
export function addUser(data) {
    return request({
        url: `${baseURL.userApi}/users`,
        method: 'post',
        data: data
    })
}


/***
 * 修改用户 Post
 * @param id 要修改的用户id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateUser(id, data) {
    return request({
        url: `${baseURL.userApi}/users/${id}`,
        method: 'post',
        data: data
    })
}



